import api from 'api';

export const feedback = api('POST /api/ai-chatbot/feedback');
